import axiosInstance from './api'
import moment from 'moment'

class TaskTemplateApi {
  async fetchDepartments(token) {
    try {
      const response = await axiosInstance.get('/tasks/department/', {
        headers: {
          Authorization: `Bearer ${token?.access}`,
        },
      })

      return response.data.data
    } catch (error) {
      throw new Error('Failed to load departments')
    }
  }

  async getTasksTemplates(token) {
    try {
      const response = await axiosInstance.get('/tasks/task-template/', {
        headers: {
          Authorization: `Bearer ${token?.access}`,
        },
      })

      return response.data.data
    } catch (error) {
      throw new Error('Failed to load tasks templates')
    }
  }

  async createTaskTemplate({ values, token }) {
    const taskData = {
      task_id: values.taskType,
      task_type: values.taskType,
      view_file_type: values.viewFile,
      department: +values.department,
      title: values.title,
      repetition: values.repetition,
    }

    if (values.deadline === 'SPECIFIC DAY') {
      taskData.deadline = values.day.toString().length === 1 ? `0${values.day}` : values.day.toString()
    } else if (values.deadline === 'DATE') {
      taskData.deadline = moment(values.date).format('DD/MM/YYYY')
    } else {
      taskData.deadline = values.deadline
    }

    try {
      const response = await axiosInstance.post('/tasks/task-template/', taskData, {
        headers: {
          Authorization: `Bearer ${token?.access}`,
        },
      })

      return response
    } catch (error) {
      throw new Error('Failed to create task template')
    }
  }

  async editTaskTemplate({ values, token }) {
    const taskData = {
      task_id: values.taskType,
      task_type: values.taskType,
      view_file_type: values.viewFile,
      department: +values.department,
      title: values.title,
      repetition: values.repetition,
      edit_single_tasks: values.editSingleTasks,
    }

    if (values.deadline === 'SPECIFIC DAY') {
      taskData.deadline = values.day.toString().length === 1 ? `0${values.day}` : values.day.toString()
    } else if (values.deadline === 'DATE') {
      taskData.deadline = moment(values.date).format('DD/MM/YYYY')
    } else {
      taskData.deadline = values.deadline
    }

    try {
      const response = await axiosInstance.put(`/tasks/task-template/${values.id}/`, taskData, {
        headers: {
          Authorization: `Bearer ${token?.access}`,
        },
      })

      return response
    } catch (error) {
      throw new Error('Failed to update task template')
    }
  }

  async deleteTaskTemplate({ id, token }) {
    try {
      const response = await axiosInstance.delete(`/tasks/task-template/${id}`, {
        headers: {
          Authorization: `Bearer ${token?.access}`,
        },
      })

      return response
    } catch (error) {
      throw new Error('Failed to delete task template')
    }
  }

  async assignTasksToClient({ values, token }) {
    const body = {
      departments: values.departments,
      client: values.client,
    }
    try {
      const response = await axiosInstance.post(`/tasks/task-template/assign/`, body, {
        headers: {
          Authorization: `Bearer ${token?.access}`,
        },
      })

      return response
    } catch (error) {
      throw new Error('Failed to assign tasks')
    }
  }
}

export default new TaskTemplateApi()
